/**
 * Extracts the `sub` claim (user id) from a JWT, without verifying its
 * signature — this is a same-user sanity check on tokens the backend itself
 * just issued to us, not an authenticity check.
 */
export function getJwtSubject(token: string): string | null {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return null

    const payload = JSON.parse(atob(parts[1]))
    return typeof payload.sub === 'string' ? payload.sub : null
  } catch {
    return null
  }
}
